import React, { useCallback } from 'react';
import styled from 'styled-components';
import Verticals from '@sunbit-dev/common/enums/Verticals';

import { BulletLine } from '@sunbit-dev/web-ui-lib';

const SGetStartedContainer = styled.main<{}>(
  ({ theme }) => `
    display: flex;
    align-items: center;
    flex-direction: column;
    width: 100%;
    color: ${theme.colors.white};
    position: relative;
    padding-bottom: 80px;
    margin-bottom: 20px;
    @media only screen and ${theme.device.max.laptopS} {
      margin-bottom: 0;
    }
  `
);

const SGetStartedTextBox = styled.div`
  display: flex;
  flex-direction: column;
  justify-items: center;
  align-items: center;
  width: 100%;
`;

const STitle = styled.div(
  ({ theme }) => `
        word-break: break-word;
        font-family: 'Poppins';
        font-weight: 800;
        text-align: center;
        padding: 180px 20px 10px 20px;
        font-size: 50px;
        line-height: 75px;
        max-width: 700px;
        @media only screen and ${theme.device.max.laptopS} {
          max-width: 450px;
          font-size: 30px;
          line-height: 45px;
          padding: 90px 20px 30px 20px;
        }

`
);

const SActionButton = styled.button(
  ({ theme }) => `
    background-color: ${theme.colors.secondaryOrange};
    width: 257px;
    height: 50px;
    color: ${theme.colors.white};
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 10px 30px;
    box-shadow: 0px 6px 14px -6px rgba(24, 39, 75, 0.12), 0px 10px 32px -4px rgba(24, 39, 75, 0.1);
    border-radius: 50px;
    margin-top: 25px;
    font-family: Poppins;
    font-weight: bold;
    font-size: 16px;
    line-height: 21px;
    border: none;
    cursor:pointer;
  `
);

const SBulletsSmallScreen = styled.div(
  ({ theme }) => `
  display: none;
  @media only screen and ${theme.device.max.laptopS} {
    display: block;
    padding: 0 30px;
  }
`
);

const SBulletText = styled(BulletLine)(
  () => `
  max-width: 400px;
  width: 100%;
`
);

export interface IGetStartedProps {
  submit: () => void;
  retailerName: string;
  vertical: Verticals;
  isDiscountTire?: boolean;
}

export const getVerticalTitle = (vertical: Verticals, retailerName: string) => {
  let title: string;

  switch (vertical) {
    case Verticals.Car_Dealerships:
      title = `Service now, pay-over-time`;
      break;
    case Verticals.Dental:
      title = `Smile now, pay-over-time`;
      break;
    default:
      title = `Buy now, pay-over-time`;
  }

  return `${title} at ${retailerName}`;
};

const GetStarted = ({ submit, retailerName, vertical, isDiscountTire }: IGetStartedProps) => {
  const handleSubmit = useCallback(() => submit(), [submit]);

  const approvalRateText = (() => {
    if (isDiscountTire) return 'Enter reference number when you checkout on discounttire.com';

    const isDentalVertical = vertical === Verticals.Dental;

    return `${isDentalVertical ? 85 : 90}% approval rate`;
  })();

  return (
    <SGetStartedContainer>
      <SGetStartedTextBox>
        <STitle data-testid="title">{getVerticalTitle(vertical, retailerName)}</STitle>
        <SBulletsSmallScreen>
          <SBulletText text={isDiscountTire ? 'Pre-qualify in 30 seconds to get a reference number' : 'No hard credit check'} color="white" />
          <SBulletText text={approvalRateText} color="white" />
          <SBulletText text={isDiscountTire ? 'Complete application and make your purchase' : 'Lightning fast response'} color="white" />
        </SBulletsSmallScreen>
        <SActionButton {...{ 'data-testid': 'get-started-btn', 'data-at': 'get-started', onClick: handleSubmit }}>Get started!</SActionButton>
      </SGetStartedTextBox>
    </SGetStartedContainer>
  );
};

export default GetStarted;
